module.exports = __webpack_public_path__ + "static/img/geotap-game-stairs-lowpoly-shape.ec37076.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/geotap-game/geotap-game-stairs-lowpoly-shape.jpg
// module id = wtl0
// module chunks = 0